import { GrfqLeg } from '#/unified-rfqs/entities/grfq/domain';
import { TwoWayValue } from '#/unified-rfqs/ui/grfq/quote-builder/form-reducer';

interface ValidationViewArgs {
  readonly quantity: string;
  readonly price: string;
  readonly legPricingEnabled: boolean;
  readonly legsPrice: readonly TwoWayValue[];
  readonly legs: readonly GrfqLeg[];
  readonly side: 'BUY' | 'SELL';
  readonly productCode: string | undefined;
}

export default function validationView({
  quantity,
  price,
  legPricingEnabled,
  legs,
  legsPrice,
  side,
  productCode,
}: ValidationViewArgs) {
  const processLegPrices = makeLegPriceProcessor(legs, side);
  const priceValidationResult = legPricingEnabled
    ? legsPrice.map(processLegPrices).every(isValidLegPrice)
    : isValidStrategyPrice(price);

  return {
    price: priceValidationResult,
    quantity: isValidQuantity(quantity, productCode),
  };
}

type LegPriceProcessor = (legPrice: TwoWayValue, index: number) => string;

function isValidStrategyPrice(value: string) {
  return isValidFloat(value);
}

function isValidLegPrice(value: string) {
  return isValidFloat(value) && isPositive(value);
}

function isValidQuantity(value: string, productCode: string | undefined) {
  if (productCode == null || !isValidFloat(value) || !isPositive(value))
    return false;
  return true;
}

function makeLegPriceProcessor(
  legs: readonly GrfqLeg[],
  side: 'BUY' | 'SELL',
): LegPriceProcessor {
  return function legPriceProcessor(legPrice, index: number) {
    const leg = legs[index]!;
    return legPrice[leg.side === side ? 0 : 1];
  };
}

function isValidFloat(value: string): boolean {
  return Number.isFinite(Number.parseFloat(value));
}

export function isPositive(value: string): boolean {
  return Number.parseFloat(value) > 0;
}
